/**
 * Care Management "market" derivation for the CASES Home card.
 *
 * @astrana/ui's Cases module (`careManagement.market`, see its
 * careManagement.seam.ts) hides "Care at Home (CAH)" unless the market is
 * CA / TX / RI (case-insensitive, trimmed). CRUCIAL asymmetry in that seam: an
 * ABSENT market (undefined / null / "") means "host did not say" and shows
 * EVERY program, i.e. CAH is visible. Any non-empty string not in CA/TX/RI
 * hides it.
 *
 * The product spec says only CA/TX/RI members may see CAH, so an unknown state
 * must fail CLOSED. We therefore never return undefined/"": an unknown or
 * malformed state maps to UNKNOWN_CARE_MANAGEMENT_MARKET, a non-empty value
 * that is not a real market, which the library treats as "outside CA/TX/RI".
 */
export const UNKNOWN_CARE_MANAGEMENT_MARKET = "UNKNOWN";

/** Normalize a member's address state to an uppercase two-letter code, or the
 *  fail-closed sentinel when absent / not a two-letter code (e.g. "California"). */
export function toCareManagementMarket(state?: string | null): string {
  const code = state?.trim().toUpperCase();
  return code && /^[A-Z]{2}$/.test(code) ? code : UNKNOWN_CARE_MANAGEMENT_MARKET;
}
